export const edos = [
  {
    code: 'AGS',
    name: 'Aguascalientes'
  },
  {
    code: 'BC',
    name: 'Baja California'
  },
  {
    code: 'BCS',
    name: 'Baja California Sur'
  },
  {
    code: 'CAMP',
    name: 'Campeche'
  },
  {
    code: 'COAH',
    name: 'Coahuila'
  },
  {
    code: 'COL',
    name: 'Colima'
  },
  {
    code: 'CHIS',
    name: 'Chiapas'
  },
  {
    code: 'CHIH',
    name: 'Chihuahua'
  },
  {
    code: 'CDMX',
    name: 'Ciudad de México'
  },
  {
    code: 'DGO',
    name: 'Durango'
  },
  {
    code: 'GTO',
    name: 'Guanajuato'
  },
  {
    code: 'GRO',
    name: 'Guerrero'
  },
  {
    code: 'HGO',
    name: 'Hidalgo'
  },
  {
    code: 'JAL',
    name: 'Jalisco'
  },
  {
    code: 'MEX',
    name: 'México'
  },
  {
    code: 'MICH',
    name: 'Michoacán'
  },
  {
    code: 'MOR',
    name: 'Morelos'
  },
  {
    code: 'NAY',
    name: 'Nayarit'
  },
  {
    code: 'NL',
    name: 'Nuevo León'
  },
  {
    code: 'OAX',
    name: 'Oaxaca'
  },
  {
    code: 'PUE',
    name: 'Puebla'
  },
  {
    code: 'QRO',
    name: 'Querétaro'
  },
  {
    code: 'QROO',
    name: 'Quintana Roo'
  },
  {
    code: 'SLP',
    name: 'San Luis Potosí'
  },
  {
    code: 'SIN',
    name: 'Sinaloa'
  },
  {
    code: 'SON',
    name: 'Sonora'
  },
  {
    code: 'TAB',
    name: 'Tabasco'
  },
  {
    code: 'TAMPS',
    name: 'Tamaulipas'
  },
  {
    code: 'TLAX',
    name: 'Tlaxcala'
  },
  {
    code: 'VER',
    name: 'Veracruz'
  },
  {
    code: 'YUC',
    name: 'Yucatán'
  },
  {
    code: 'ZAC',
    name: 'Zacatecas'
  }
]

export function getEdoName(code){
  var f = edos.filter(d => d.code == code);
  return f[0].name;
}

export function getCode(name){
  console.log('Name', name);
  if(name == "Distrito Federal"){
    name = "Ciudad de México";
  }
  var f = edos.filter(d => d.name == name);
  if(f.length){
    return f[0].code;
  }else{
    console.log('NAME', name);
    return false;
  }
}

/* Créditos */
export const creditos = [
  {
    name: 'Investigación',
    persons: [
      {
        name: 'Arturo Ángel',
        tw: 'arturoangel20'
      },
      {
        name: 'Agustín Salgado',
        tw: 'AgustinSalgado'
      }
    ]
  },
  {
    name: 'Video',
    persons: [
      {
        name: 'Alejandro Ponce'
      },
      {
        name: 'Carlo Echegoyen',
        tw: 'CarloEchegoyen'
      },
      {
        name: 'Elizabeth C. Larios',
        tw: 'elycruzla'
      },
      {
        name: 'Ethan Murillo'
      },
      {
        name: 'Juan Ibarra'
      },
      {
        name: 'Rodrigo Crespo',
        tw: 'rodrigocrespo_'
      }
    ]
  },
  {
    name: 'Desarrollo web, diseño e ilustración',
    persons: [
      {
        name: 'Mauricio M. Robles',
        tw: 'lopsum'
      },
      {
        name: 'Andrea Paredes',
        tw: 'Driu_Paredes'
      },
      {
        name: 'Elisa Terán'
      },
      {
        name: 'Jesús Santamaría',
        tw: 'RE_Ilustrador'
      },
      {
        name: 'Yosune Chamizo Alberro',
        tw: '_Yosune'
      }
    ]
  },
  {
    name: 'Análisis y revisión de datos',
    persons: [
      {
        name: 'Berta G. Díaz Martínez',
        tw: 'bertisd'
      }
    ]
  },
  {
    name: 'Redes sociales',
    persons: [
      {
        name: 'Jorge Ramis',
        tw: 'jramiiis'
      },
      {
        name: 'Armando Mora',
        tw: 'Armando_Mora_'
      }
    ]
  },
  {
    name: 'Edición y coordinación general',
    persons: [
      {
        name: 'Tania L. Montalvo',
        tw: 'tanlmont'
      }
    ]
  },
  {
    name: 'Subdirección de información',
    persons: [
      {
        name: 'Francisco Sandoval',
        tw: 'Mrterremoto'
      }
    ]
  },
  {
    name: 'Dirección general',
    persons: [
      {
        name: 'Daniel Moreno',
        tw: 'dmorenochavez'
      }
    ]
  },
  {
    name: 'Asesoría',
    persons: [
      {
        name: 'Asociación Nacional de Abogados Democráticos (ANAD)',
      },
      {
        name: 'EQUIS Justicia para las Mujeres',
      },
      {
        name: 'El Poder del Consumidor',
      },
      {
        name: 'Grupo de Acción por los Derechos Humanos y la Justicia Social',
      },
      {
        name: 'Clínica de Justicia Laboral del ITAM',
      },
      {
        name: 'Asamblea de Pueblos Indígenas del Istmo en Defensa de la Tierra y el Territorio',
      },
      {
        name: 'ABCNoticias.mx',
      },
      {
        name: 'Luis Miguel López Mena',
      },
      {
        name: 'Javier Martín Reyes',
      },
      {
        name: 'Ana Laura Magaloni Kerpel',
      },
      {
        name: 'Lilian Chapa Koloffon',
      },
      {
        name: 'Estefanía Vela Barba',
      },
    ]
  }
]

export const creditos_wjp = [
  {
    name: 'Dirección de Investigación',
    persons: [
      {
        name: 'Alejandro Ponce Rodríguez',
      },
      {
        name: 'Jorge Antonio Morales Alfaro',
      },
      {
        name: 'Leslie Solis Saravia',
      },
    ]
  },
  {
    name: 'Equipo de Investigación',
    persons: [
      {
        name: 'Irene Heras',
      },
      {
        name: 'Lucía Estefanía González Medel',
      },
      {
        name: 'Eréndira González Portillo',
      },
      {
        name: 'Camilo Gutiérrez Patiño',
      },
      {
        name: 'Fernando Gutiérrez Omede',
      },
      {
        name: 'Sarah Chamness Long',
      },
      {
        name: 'Mario Rodriguez Vigueras',
      },
    ]
  },
]

export const graficosSource = [
  "https://www.animalpolitico.com/wp-content/uploads/2019/11/1_c.png",
  "https://www.animalpolitico.com/wp-content/uploads/2019/11/2_c.png",
  "https://www.animalpolitico.com/wp-content/uploads/2019/11/3_c.png",
  "https://www.animalpolitico.com/wp-content/uploads/2019/11/grafico_1_cantidad-de-quejas-1.png",
  "https://www.animalpolitico.com/wp-content/uploads/2019/11/grafico_3_10-principales-motivos.png",
  "https://www.animalpolitico.com/wp-content/uploads/2019/11/grafico_1_familiar.png",
  "https://www.animalpolitico.com/wp-content/uploads/2019/11/grafico_2_familiar.png",
  "https://www.animalpolitico.com/wp-content/uploads/2019/11/grafico_3_presupuesto-juicio-familiar.png",
  "https://www.animalpolitico.com/wp-content/uploads/2019/11/Screen_Shot_2019-11-26_at_12.24.52_PM.png",
  "https://www.animalpolitico.com/wp-content/uploads/2019/11/grafico_2_estados.png",
  "https://www.animalpolitico.com/wp-content/uploads/2019/11/grafico_3_junta-laboral.png"
];
